import { Colors, Heading, Icon, Text } from '@amelio/ui-library';

import { useAmelioTranslations } from '@/hooks';

interface LockedTemplateSectionProps {
    heading: string;
    /** Offers Performance PRO, which the section's review type belongs to. */
    onUnlock: () => void;
    dataTestId: string;
}

/**
 * A template section whose review type the company's plan does not include: it keeps its place and
 * name in the page, offers no template, and leads to the upgrade instead.
 */
export const LockedTemplateSection = ({
    heading,
    onUnlock,
    dataTestId,
}: LockedTemplateSectionProps) => {
    const { t } = useAmelioTranslations();

    return (
        <div
            className={'flex flex-wrap items-center justify-between gap-4'}
            data-testid={dataTestId}
        >
            {/* Same title as the open sections, where clicking it folds the section; here it unlocks. */}
            <button
                type={'button'}
                className={'flex cursor-pointer items-center gap-2 border-none bg-transparent p-0'}
                onClick={onUnlock}
                data-testid={`${dataTestId}-heading`}
            >
                <Heading
                    level={3}
                    weight={'semibold'}
                >
                    {heading}
                </Heading>

                <Icon
                    name={'security-lock'}
                    color={Colors.BASE_400}
                    ariaLabel={t('performancePro.locked')}
                />
            </button>

            <div className={'flex flex-wrap items-center gap-3'}>
                <Text
                    size={'small'}
                    color={Colors.BASE_400}
                >
                    {t('performancePro.lockedTitle')}
                </Text>

                <button
                    type={'button'}
                    className={
                        'cursor-pointer border-none bg-transparent p-0 text-sm font-medium underline transition-colors hover:text-teal-500'
                    }
                    onClick={onUnlock}
                    data-testid={`${dataTestId}-unlock`}
                >
                    {t('performancePro.unlockAction')}
                </button>
            </div>
        </div>
    );
};
